function init() {
  linkFieldInput($('#gift_card_form_buyer_email'), $('#user_email'));
  linkNameInput($('#gift_card_form_buyer_name'), $('#user_first_name'), $('#user_last_name'));
}

function linkFieldInput($emailField1, $emailField2) {
  $emailField1.focusout(() => {
    if ($emailField1.val() && isEmpty($emailField2.val())) {
      $emailField2.val($emailField1.val());
    }
  });
}

function linkNameInput($fullName, $firstName, $lastName) {
  $fullName.focusout(() => {
    if ($fullName.val()) {
      const parts = $fullName.val().split(' ');
      const firstName = parts.shift();
      const lastName = parts.join(' ');
      if (isEmpty($firstName.val()) && isEmpty($lastName.val())) {
        $firstName.val(firstName);
        $lastName.val(lastName);
      }
    }
  });
}

function isEmpty(string) {
  return (!string || string.length === 0);
}

export default {
  init,
};
